// src/components/Newsletter.js
import React from "react";

const Newsletter = ({ visible = true, newsletterEmail = "", setNewsletterEmail = () => {}, onSubmit = (e) => { e.preventDefault(); alert('Subscribed (demo)'); } }) => {
  return (
    <section
      id="newsletter"
      className={`pt-6 pb-12 bg-green-800 transition-all duration-700 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-20"
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-bold text-white mb-4">Subscribe to Our Newsletter</h2>
        <p className="text-green-100 mb-6">Stay updated with our latest classes, events, and Islamic learning resources</p>

        <form onSubmit={onSubmit} className="max-w-md mx-auto flex gap-2">
          <input
            type="email"
            value={newsletterEmail}
            onChange={(e) => setNewsletterEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-4 py-3 rounded-lg border-0 focus:ring-2 focus:ring-yellow-500"
            required
          />
          <button type="submit" className="bg-yellow-500 hover:bg-yellow-600 text-green-900 px-6 py-3 rounded-lg font-medium transition-colors">
            Subscribe
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
